/* Hero slider — cross-fading full-bleed slides for sections/home-hero.liquid.

   Loaded only when the hero has more than one block, so a single-slide hero
   never pays for it.

   Autoplay stops whenever the visitor is engaged with the hero or cannot see
   it: pointer over it, keyboard focus inside it, or the tab in the background.
   A carousel that keeps moving while someone is reading a headline or tabbing
   to its button is a usability fault, not a feature — and a timer left running
   in a hidden tab makes the slide jump the moment they return. */
(function () {
  function init(root) {
    if (!root || root.dataset.heroWired) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    if (slides.length < 2) return;
    root.dataset.heroWired = '1';

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    var every = (parseFloat(root.getAttribute('data-autoplay')) || 0) * 1000;
    /* Honour the OS setting rather than the theme's: a visitor who asks for
       reduced motion gets the first slide and the dots, never a timer. */
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var at = 0;
    var timer = null;
    var observer = null;

    function show(n) {
      at = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var on = i === at;
        s.classList.toggle('is-on', on);
        /* Inactive slides leave the a11y tree AND the tab order — otherwise a
           screen reader reads every season's headline in sequence, and their
           buttons stay tabbable underneath the visible one. aria-hidden alone
           does the first half only, which strands focus on an invisible button;
           inert does both, with aria-hidden kept as the older-browser fallback. */
        if (on) {
          s.removeAttribute('aria-hidden');
          s.removeAttribute('inert');
        } else {
          s.setAttribute('aria-hidden', 'true');
          s.setAttribute('inert', '');
        }
      });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === at ? 'true' : 'false'); });
    }

    /* Give every slide the same shape.

       The overlay is anchored to the bottom of the hero, so each row rides on
       the height of whatever sits below it: a season whose intro wraps to three
       lines where another takes two shifts that slide's headline, eyebrow and
       tag up by a line, and the copy appears to twitch as the hero turns over
       rather than simply change.

       Reserving a fixed number of lines in CSS cannot work — the wrap point
       moves with the viewport and with whatever the merchant types. So measure
       the tallest of each row at the live width and publish it as a custom
       property the slides all reserve against. Clearing the property first is
       what makes this idempotent: without it each pass would measure its own
       previous reservation and the block could only ever grow. */
    var EQUALISE = [
      { sel: '.hero__headline', prop: '--hero-line-headline' },
      { sel: '.hero__intro',    prop: '--hero-line-intro' }
    ];
    function equalise() {
      /* The resize listener lives on window and outlives this section, so a
         Theme Editor edit would otherwise leave a stale instance measuring
         detached slides on every resize. Same reasoning as start(). */
      if (!root.isConnected) {
        window.removeEventListener('resize', equalise);
        if (observer) { observer.disconnect(); observer = null; }
        return;
      }
      EQUALISE.forEach(function (row) {
        root.style.removeProperty(row.prop);
        var tallest = 0;
        slides.forEach(function (s) {
          var el = s.querySelector(row.sel);
          if (el) { tallest = Math.max(tallest, el.getBoundingClientRect().height); }
        });
        if (tallest) { root.style.setProperty(row.prop, Math.ceil(tallest) + 'px'); }
      });
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (!every || still) return;
      /* The visibilitychange listener below lives on document and outlives this
         section, so a Theme Editor edit would otherwise leave the previous
         instance's timer ticking against detached slides forever. */
      if (!root.isConnected) return;
      timer = setInterval(function () { show(at + 1); }, every);
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { show(i); start(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    /* The wrap point moves with the width, so the rows are re-measured whenever
       the hero changes size. Both signals are wired rather than one:
       ResizeObserver catches the hero being resized by something other than the
       window — the Theme Editor's preview pane is the case that matters — while
       the resize event still fires in contexts where observer callbacks are
       throttled. equalise() is idempotent, so running it twice costs a measure
       and changes nothing. */
    equalise();
    if (window.ResizeObserver) { observer = new ResizeObserver(equalise); observer.observe(root); }
    window.addEventListener('resize', equalise);
    /* Geist is self-hosted and may swap in after the first measurement, which
       would otherwise leave the reservation a line off. */
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(equalise); }

    show(0);
    start();
  }

  function boot() { init(document.querySelector('[data-hero]')); }

  /* The Theme Editor swaps the section's markup when a slide is edited, which
     drops the old element (and its flag) and needs the new one wired. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) init(e.target.querySelector('[data-hero]'));
  });

  boot();
})();
